import React from 'react'
import {connect} from 'react-redux'
import Address from './views/address'
import GovCareRegistration from './views/gov-care-registration'
import OperationalProfile from './views/operational_profile'
import Capacity from './views/capacity'
import './views/details.css'

export const Details = ({gov_care_registration, operational_profile, address, capacity}) => (
  <div className="details-screen">
    <GovCareRegistration gov_care_registration={gov_care_registration} />
    <OperationalProfile operational_profile={operational_profile} />
    <Address address={address} />
    <Capacity capacity={capacity} />
  </div>
)

const mapStateToProps = (state) => ({
  address: state.gov_care_registration_details.address,
  capacity: state.gov_care_registration_details.capacity,
  operational_profile: state.gov_care_registration_details.operational_profile,
})

export default connect(mapStateToProps)(Details)


// WEBPACK FOOTER //
// ./src/gov-care-registration-details/container.jsx